import { site } from "../content/site";
import { Reveal } from "./Reveal";

export const WhyBanga = () => (
  <section className="border-t border-gray-200 bg-white" data-testid="why-banga-section">
    <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-4 py-20 sm:px-6 lg:grid-cols-2 lg:gap-20 lg:px-8 lg:py-24">
      <Reveal>
        <p className="text-xs font-semibold uppercase tracking-[0.14em] text-brand">{site.why.eyebrow}</p>
        <h2 data-testid="why-heading" className="mt-3 font-heading text-3xl font-bold tracking-tight text-gray-900 md:text-4xl">
          {site.why.heading}
        </h2>
      </Reveal>
      <Reveal delay={0.1} className="space-y-5">
        {site.why.paragraphs.map((p, i) => (
          <p key={i} className="text-base leading-relaxed text-gray-600 md:text-lg">
            {p}
          </p>
        ))}
      </Reveal>
    </div>
  </section>
);
